module.exports = __webpack_public_path__ + "static/img/comment-icon.0c9877a0.svg";